// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './firebase/firebase-config';
import App from './App';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import 'react-datepicker/dist/react-datepicker.css';

const theme = extendTheme({});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);